// extracted by mini-css-extract-plugin
export default {"stepButtons":"Index_stepButtons__3mhzJ","title":"Index_title__2FAhQ"};